// src/config/api.js

const getApiBaseUrl = () => {
  const { hostname, port } = window.location;

  console.log("Current hostname:", hostname, "Port:", port); // Debug log

  // 🔹 Localhost
  if (hostname === "localhost") {
    return "ws://192.168.1.116:8700";
    // http://122.176.232.35:8080/
  }

  // 🔹 Local network (192.168.1.109:8000)
  if (hostname === "192.168.1.109" && port === "8000") {
    return "ws://192.168.1.116:8700";
  }

  // 🔹 Public IP (122.176.232.35:8080)
  if (hostname === "122.176.232.35" && port === "8080") {
    return "ws://192.168.1.116:8700";
  }

  // 🔹 Staging (139.5.190.205:8999)
  if (hostname === "139.5.190.205" && port === "8999") {
    return "ws://122.176.232.35:8700";
  }

  // 🔹 Production domain
  if (hostname === "hhc.hospitalguru.in") {
    return "wss://cti.hospitalguru.in:8700";
  }

  // 🔹 Default fallback
  return "wss://cti.hospitalguru.in:8700";
};

export const SOCKET_URL_CALL = getApiBaseUrl();